import { defineMessage } from 'services/localization';

export const messages = {
    registerText: defineMessage('sign_up'),
    loginText: defineMessage('log_in'),
};
